let isBrowser = typeof window !== 'undefined';
let Modernizr = isBrowser ? require('../utils/modernizr.custom') : undefined;

export default {

  all(styles) {
    var prefixedStyle = {};
    for (var key in styles) {
      prefixedStyle[this.single(key)] = styles[key];
    }
    return prefixedStyle;
  },

  set(style, key, value) {
    style[this.single(key)] = value;
  },

  single(key) {
    return isBrowser ? Modernizr.prefixed(key) : key;
  },

  singleHyphened(key) {
    var str = this.single(key);

    return !str ? key : str.replace(/([A-Z])/g, function(str,m1){
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/,'-ms-');
  }

};


/** WEBPACK FOOTER **
 ** ./src/utils/auto-prefix.js
 **/